'use client';

import { usePathname } from 'next/navigation';
import Script from 'next/script';
import { useEffect, useState } from 'react';

const pageview = () => {
    (window as any).fbq('track', 'PageView');
};

const event = (name, options = {}) => {
    (window as any).fbq('track', name, options);
};

export default function FacebookPixel({ facebookPixelId }: { facebookPixelId: string }) {
    const [loaded, setLoaded] = useState(false);
    const pathname = usePathname();

    useEffect(() => {
        if (!loaded) return;

        pageview();
    }, [pathname, loaded]);

    if (!facebookPixelId) return null;

    return (
        <Script
            id="fb-pixel"
            strategy="afterInteractive"
            onLoad={() => setLoaded(true)}
            dangerouslySetInnerHTML={{
                __html: `
                    function initializeFacebookPixel(f, b, e, v, n, t, s) {
                        if (f.fbq) return;
                        n = f.fbq = function () {
                            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
                        };
                        if (!f._fbq) f._fbq = n;
                        n.push = n;
                        n.loaded = !0;
                        n.version = "2.0";
                        n.queue = [];
                        t = b.createElement(e);
                        t.async = !0;
                        t.src = v;
                        s = b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t, s);
                    }

                    initializeFacebookPixel(
                        window,
                        document,
                        "script",
                        "https://connect.facebook.net/en_US/fbevents.js",
                    );

                    window.fbq("init", "${facebookPixelId}");
                `,
            }}
        />
    );
}
